module.exports = __webpack_public_path__ + "static/media/gauge.97a1be67.png";